import type {
  AdminLeadDuplicateCandidateSetRevision,
  AdminLeadDuplicateSummary,
} from "./crm-duplicates";
import type { LeadId } from "./crm";

export type GuestId = string & { readonly __brand: "GuestId" };
export type LeadGuestConversionId = string & {
  readonly __brand: "LeadGuestConversionId";
};
export type AdminLeadGuestConversionPreflightRevision = string & {
  readonly __brand: "AdminLeadGuestConversionPreflightRevision";
};

export const adminLeadGuestConversionPreflightRevisionMaxLength = 256;

export const leadGuestDispositions = ["CREATED", "REUSED"] as const;
export type LeadGuestDisposition = (typeof leadGuestDispositions)[number];

export const leadGuestDuplicateReviewDecisions = [
  "NO_POSSIBLE_MATCHES",
  "CONFIRMED_DISTINCT_CONTACT",
] as const;
export type LeadGuestDuplicateReviewDecision =
  (typeof leadGuestDuplicateReviewDecisions)[number];

export interface AdminLeadGuestConversionRecord {
  readonly conversionId: LeadGuestConversionId;
  readonly leadId: LeadId;
  readonly guestId: GuestId;
  readonly guestDisposition: LeadGuestDisposition;
  readonly duplicateReviewDecision: LeadGuestDuplicateReviewDecision;
  readonly duplicateCandidateCount: number;
  readonly convertedAt: string;
}

export interface AdminLeadGuestConversionDuplicateReview {
  readonly leadId: LeadId;
  readonly candidateSetRevision: AdminLeadDuplicateCandidateSetRevision;
  readonly summary: AdminLeadDuplicateSummary;
}

export interface AdminLeadGuestConversionRequest {
  readonly leadId: LeadId;
  readonly expectedUpdatedAt: string;
  readonly conversionPreflightRevision: AdminLeadGuestConversionPreflightRevision;
  readonly expectedDuplicateCandidateSetRevision: AdminLeadDuplicateCandidateSetRevision;
  readonly expectedDuplicateCandidateCount: number;
  readonly duplicateReviewDecision: LeadGuestDuplicateReviewDecision;
}

export type AdminLeadGuestConversionOutcome =
  | {
      readonly kind: "confirmed";
      readonly conversion: AdminLeadGuestConversionRecord;
    }
  | { readonly kind: "conflict" }
  | { readonly kind: "rejected" };
